import { Component, OnInit, inject, DestroyRef, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

import { delay, filter, noop, tap } from 'rxjs';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '@env/environment';
import { VersionCheckService, PusherService, HubspotChatbotService } from 'app/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styles: [
    `
      :host {
        display: flex;
        flex: 1 1 auto;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class AppComponent implements OnInit {
  public showProgressBar: WritableSignal<boolean> = signal(false);

  private readonly _router = inject(Router);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _pusherService = inject(PusherService);
  private readonly _versionCheckService = inject(VersionCheckService);
  private readonly _hubspotChatbotService = inject(HubspotChatbotService);

  ngOnInit(): void {
    this._pusherService.registerForPusher();
    this._hubspotChatbotService.loadChatbotScript();
    this.toggleGlobalNavigationLoading();

    if (['qaUI', 'stagingUI', 'productionUI'].includes(environment.env)) {
      if (environment.production) {
        datadogRum.init(environment.dataDog);
      }
    }

    this.executeVersionCheck();

    // Segment/Intercom Analytics
    this._router.events.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        analytics.page(event.url);
      }

      if (event instanceof NavigationEnd) {
        //adding this console.log to check if the version check is working on qa environment
        this.executeVersionCheck();
      }
    });
  }

  private executeVersionCheck(): void {
    if (environment.production) {
      this._versionCheckService.initVersionCheck(environment.versionCheckURL);
    }

    if (['qaUI', 'stagingUI', 'productionUI'].includes(environment.env)) {
      if (environment.production) {
        this._versionCheckService.initVersionCheck(environment.versionCheckURL);
      }
    }
  }

  private toggleGlobalNavigationLoading(): void {
    this._router.events
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        delay(100),
        filter(
          (event) =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
        tap((event) => {
          if (event instanceof NavigationStart) this.showProgressBar.set(true);
          else this.showProgressBar.set(false);
        }),
      )
      .subscribe(noop);
  }
}
